// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3twGE","productName":"Table_productName__3dNo6"};